import React from 'react'
import CardsPhysicalCards from 'src/app/Cards/CardsPhysicalCards'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { cardsPhysicalCardsRouteProps } from 'src/navigation/routeProps'

const CardsPhysicalCardsAppRoute: AppRoute = {
  id: AppLocation.PhysicalCards,
  routeProps: cardsPhysicalCardsRouteProps,
  component: <CardsPhysicalCards />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default CardsPhysicalCardsAppRoute
